export default "__VITE_ASSET__DSkGwHnw__"